// @flow
import { createConsumer } from '@rails/actioncable';
import Log from './Log';

type AgendaChange = {
  type: 'created' | 'updated' | 'destroyed',
  id: number,
  date: ?string,
  previousDate?: string,
};

type AgendaHandlers = {
  onChange: (change: AgendaChange) => void,
  onConnected: () => void,
};

// window.API is https://…; the Action Cable server lives at /cable on the same host.
// The token is read on every (re)connect, since the API rotates it.
const cableUrl = (getToken: () => ?string) => () => (
  `${String(window.API).replace(/^http/, 'ws')}/cable?token=${encodeURIComponent(getToken() || '')}`
);

// Opens a socket dedicated to one clinic's agenda. Returns a function that closes it.
export function subscribeAgenda(clinicId: number, getToken: () => ?string, handlers: AgendaHandlers) {
  const consumer = createConsumer(cableUrl(getToken));

  consumer.subscriptions.create({ channel: 'AgendaChannel', clinic_id: clinicId }, {
    connected() {
      // Changes made before the subscription was live were missed: those after the agenda's
      // first fetch on the initial connect, or while offline/in background on a reconnect.
      handlers.onConnected();
    },
    rejected() {
      Log.warn('Realtime: agenda subscription rejected for clinic', clinicId);
      consumer.disconnect();
    },
    received(change: AgendaChange) {
      handlers.onChange(change);
    },
  });

  return () => consumer.disconnect();
}

export default { subscribeAgenda };
